var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBrandHealth = function SvgBrandHealth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.824,
    height: 51.001
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 47206"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.768 0H20.054a7.62 7.62 0 0 0-7.609 7.61h4.477a3.136 3.136 0 0 1 3.133-3.133h12.713a3.136 3.136 0 0 1 3.133 3.133h4.477A7.62 7.62 0 0 0 32.768 0",
    "data-name": "Path 44845"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.554 8.923H2.27A2.27 2.27 0 0 0 0 11.193v37.538a2.27 2.27 0 0 0 2.27 2.27h48.284a2.27 2.27 0 0 0 2.27-2.27V11.193a2.27 2.27 0 0 0-2.27-2.27m-10.49 22.144a3.234 3.234 0 0 1-3.236 3.234H31.2v5.629a3.235 3.235 0 0 1-3.236 3.235h-2.425a3.235 3.235 0 0 1-3.236-3.234v-5.629h-5.628a3.233 3.233 0 0 1-3.234-3.234v-2.427a3.234 3.234 0 0 1 3.234-3.233h5.629v-5.63a3.234 3.234 0 0 1 3.236-3.235h2.424a3.235 3.235 0 0 1 3.236 3.235v5.63h5.627a3.236 3.236 0 0 1 3.237 3.233Z",
    "data-name": "Path 44846"
  }))));
};
export default SvgBrandHealth;